<template>
  <div class="home">
    <el-container>
      <el-aside width="0"></el-aside>
      <el-main v-loading="loading">
        <div class="content">
          <el-row>
            <el-col :span="18">
              <div class="app-wrap"><app-list :userInfo="userInfo"></app-list></div>
              <div class="project-wrap">
                <project-list :userInfo="userInfo"></project-list>
              </div>
            </el-col>
            <el-col :span="6">
              <div
                ref="figure"
                id="carousel-figure"
                class="carousel-figure pointer"
                @click="gotoAppTemplateCenter"
                :style="{ 'background-image': `url(${carousel})`, height: figureHeight + 'px' }"
              ></div>
              <div class="todo-list"><todo-list :userInfo="userInfo"></todo-list></div>
            </el-col>
          </el-row>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import ProjectList from "./ProjectList"
import AppList from "./AppList"
import TodoList from "./TodoList"

export default {
  name: "Home",
  components: { ProjectList, AppList, TodoList },
  data: function() {
    return {
      loading: false,
      carousel: require("@/assets/images/carousel.png"),
      figureHeight: 0
    }
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  mounted() {
    let elementResizeDetectorMaker = require("element-resize-detector")
    let erd = elementResizeDetectorMaker()
    erd.listenTo(document.getElementById("carousel-figure"), () => {
      this.figureHeight = (this.$refs.figure.clientWidth * 128) / 264
    })
  },
  created() {
    this.refresh()
  },
  methods: {
    async refresh() {
      this.loading = true
      if (!this.userInfo.companyId) {
        this.$message.warning("请先选择企业")
        this.$router.push({ name: "system-personal-companies" })
        return
      }
      this.loading = false
    },
    gotoAppTemplateCenter() {
      const { href } = this.$router.resolve({
        name: "app-template-center",
        query: { from: "home" }
      })
      window.open(href, "_blank")
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  padding-bottom: 40px;
  .content {
    margin: 0 100px 20px 100px;
  }
  .app-wrap,
  .project-wrap {
    margin: 0 10px 20px 0;
  }
  .carousel-figure {
    background-size: contain;
    background-position: top;
    background-repeat: no-repeat;
    margin: 0 0 20px 10px;
  }
  .todo-list {
    margin: 0 0 20px 10px;
  }
  .todo-list {
    height: 700px;
  }
}
</style>
